// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"33":"7433977c0e2b959d5a0d","486":"0ce38aea3dfce9634c80","518":"d8e3085b1a705eefbef5","631":"35283817c7cb31176152","636":"bda06126a6ee776a1c75","725":"8e1698572bb582939edc","866":"32090b0dde3e3479cc06","998":"6b35474f65ccda38b1bf"}[chunkId] + ".js";
};